import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-328dbdbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-4 heading-4 f-roboto fw-light" }, "Bulk Behaviors", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-4 f-roboto fw-light grey-1 mb-32 text-center" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-4 f-roboto fw-light grey-1 mb-32 text-center" }, " Import new data allows you to add additional partner data, delete all current data, import a new data set or export all partner data. ", -1))
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Select behavior below", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex align-items-center p-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Upload Successfully Complete.", -1))
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_type_drop_down = _resolveComponent("upload-type-drop-down")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_gray_text = _resolveComponent("gray-text")!
  const _component_upload_page_progress = _resolveComponent("upload-page-progress")!
  const _component_upload_box = _resolveComponent("upload-box")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_title_text = _resolveComponent("title-text")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_upload_type_drop_down, {
            type: _ctx.uploadType,
            label: _ctx.uploadLabel,
            "have-permission-to-download": _ctx.havePermissionToDownload,
            onOnTypeChange: _ctx.uploadTypeIsChanged
          }, null, 8, ["type", "label", "have-permission-to-download", "onOnTypeChange"]),
          (!_ctx.isAllPartnerDataDownloading && _ctx.uploadType === 3)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                variant: "base",
                class: "mr-10 mt-10",
                onClick: _ctx.downloadAllPartnerData
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Start download")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isAllPartnerDataDownloading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ProgressBar, { progress: _ctx.downloadProgress }, null, 8, ["progress"]),
                  _createVNode(_component_gray_text, { class: "ml-10 mt-10 fz-14" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Generate and Download in progress...")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "btn btn-default mr-10",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abortDownload && _ctx.abortDownload(...args)))
                  }, "Cancel download")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadType !== 3)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.fileStatus)
                  ? (_openBlock(), _createBlock(_component_upload_page_progress, {
                      key: 0,
                      class: "mt-24",
                      "percent-progress": _ctx.percentProgress,
                      state: _ctx.fileStatus.state || undefined
                    }, null, 8, ["percent-progress", "state"]))
                  : (_openBlock(), _createBlock(_component_upload_box, {
                      key: 1,
                      class: "mt-24",
                      onOnChosen: _ctx.onFileChosen
                    }, null, 8, ["onOnChosen"]))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.uploadCompletedModal.isOpen.value,
        onOnCancel: _ctx.uploadCompletedModal.close,
        onOnConfirm: _ctx.uploadCompletedModal.close
      }, {
        content: _withCtx(() => [
          _hoisted_9
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Back to Dashboard")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.errorModal.isOpen.value
      }, {
        content: _withCtx(() => [
          _createVNode(_component_title_text, null, {
            default: _withCtx(() => [
              _createTextVNode("Your upload is failed!")
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "red",
            onClick: _ctx.errorModal.close
          }, {
            default: _withCtx(() => [
              _createTextVNode("Try Again")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back to Dashboard ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-visible"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmDeleteFilesModal.isOpen.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_title_text, null, {
              default: _withCtx(() => [
                _createTextVNode("This will delete all data")
              ]),
              _: 1
            }),
            _createVNode(_component_gray_text, null, {
              default: _withCtx(() => [
                _createTextVNode("'Type DELETE' to remove all data")
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deleteValue) = $event)),
              class: "input-confirm-delete",
              type: "text",
              placeholder: "DELETE"
            }, null, 512), [
              [_vModelText, _ctx.deleteValue]
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "red",
            disabled: _ctx.confirmDeleteFilesConfirmButtonDisabled,
            onClick: _ctx.importAndReplace
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete data")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            disabled: true,
            onClick: _ctx.handleConfirmDeleteFilesModalClose
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible"]),
      _createVNode(_component_confirm_delete_modal, {
        "is-open": _ctx.confirmDeleteDataAndImportNewModal.isOpen.value,
        title: "Are you sure you want to delete all data and import new data?",
        subtitle: "Type delete to  confirm action",
        "confirm-button-text": "Delete all data and import new data",
        onOnConfirm: _ctx.confirmDeleteDataAndImportNewModalSecondModal.open,
        onOnCancel: _ctx.confirmDeleteDataAndImportNewModal.close
      }, null, 8, ["is-open", "onOnConfirm", "onOnCancel"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmDeleteDataAndImportNewModalSecondModal.isOpen.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_title_text, null, {
              default: _withCtx(() => [
                _createTextVNode("This will delete all data and import new data")
              ]),
              _: 1
            })
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "red",
            onClick: _cache[4] || (_cache[4] = () => {
            _ctx.uploadType = 2;
            _ctx.confirmDeleteDataAndImportNewModalSecondModal.close();
            _ctx.confirmDeleteDataAndImportNewModal.close();
          })
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            disabled: false,
            onClick: _cache[5] || (_cache[5] = () => {
            _ctx.confirmDeleteDataAndImportNewModalSecondModal.close();
            _ctx.confirmDeleteDataAndImportNewModal.close();
          })
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-visible"])
    ]),
    _: 1
  }))
}